import { Chip, SvgIconProps } from '@mui/material';
import React from 'react';

interface FilterChipProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  icon?: React.ReactElement<SvgIconProps>;
  disabled?: boolean;
}

const FilterChip: React.FC<FilterChipProps> = ({ label, checked, onChange, icon, disabled }) => {
  const handleClick = () => {
    onChange(!checked);
  };

  return (
    <Chip
      label={label}
      color={checked ? 'primary' : 'default'}
      onClick={handleClick}
      variant={checked ? 'filled' : 'outlined'}
      icon={icon}
      disabled={disabled}
    />
  );
};

export default FilterChip;
